export default "__VITE_ASSET__BtyKi5x$__"